/**
 * UGC Mock 数据生成器
 * 用于测试滚动加载功能
 */

// 随机标题库
const titleTemplates = [
  "我的仙境传说回忆录",
  "超级可爱的时装分享",
  "今天拍的美美照片",
  "回忆那些年的冒险",
  "最喜欢的游戏瞬间",
  "和朋友一起的快乐时光",
  "这个BOSS太难打了",
  "终于拿到心仪的装备",
  "新手村的美好回忆",
  "公会活动精彩瞬间",
  "PVP战斗精彩集锦",
  "打卡普隆德拉",
  "梦幻般的游戏场景",
  "我的角色成长之路",
  "难忘的组队经历"
];

// 随机内容库
const contentTemplates = [
  "这是我在游戏里最难忘的时刻！",
  "和大家分享一下今天的收获~",
  "终于完成了这个成就，太开心了！",
  "感谢队友的帮助，一起加油！",
  "这个地图的风景真的太美了",
  "新版本内容超级精彩",
  "推荐给所有玩家体验",
  "记录下这个特殊的瞬间",
  "希望大家喜欢我的分享",
  "期待下次的冒险之旅",
  "游戏让我认识了很多朋友",
  "每天都有新的惊喜",
  "这款游戏陪伴我很久了",
  "感谢官方的精心制作",
  "继续努力升级中"
];

// 图片URL库
const imageUrls = [
  "https://cdnimages.awselbcombine.com/public_images/rogcy/2025/07/28/1753692855910.1514.png",
  "https://cdnimages.awselbcombine.com/public_images/rogcy/2025/07/28/1753692855910.1515.png",
  "https://cdnimages.awselbcombine.com/public_images/rogcy/2025/07/28/1753692855910.1516.png",
  "https://cdnimages.awselbcombine.com/public_images/rogcy/2025/07/28/1753692855910.1517.png",
  "https://cdnimages.awselbcombine.com/public_images/rogcy/2025/07/28/1753692855910.1518.png"
];

// 用户名前缀
const userPrefixes = ["gogl", "fb", "apple", "steam", "guest"];

/**
 * 生成随机整数
 */
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * 生成随机日期
 */
function randomDate(start, end) {
  const date = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  return date.toISOString().slice(0, 19).replace('T', ' ');
}

/**
 * 生成单条 UGC 数据
 */
function generateUgcItem(id) {
  const uid = randomInt(1000000000, 9999999999);
  const userPrefix = userPrefixes[randomInt(0, userPrefixes.length - 1)];
  const userId = randomInt(100000000, 999999999);
  const likeCount = randomInt(0, 9999);
  const isLike = Math.random() > 0.5 ? 1 : 0;
  
  // 随机选择1-3张图片
  const imageCount = randomInt(1, 3);
  const selectedImages = [];
  for (let i = 0; i < imageCount; i++) {
    selectedImages.push(imageUrls[randomInt(0, imageUrls.length - 1)]);
  }
  
  const startDate = new Date('2025-01-01');
  const endDate = new Date('2025-10-11');
  const createTime = randomDate(startDate, endDate);
  
  return {
    ID: String(id),
    ACTIVITY_ID: "3422",
    UID: String(uid),
    LOGIN_ACCOUNT: `${userPrefix}:${userId}`,
    UGC_TYPE: String(randomInt(4, 6)), // 4:回忆录, 5:时装, 6:照片
    LANGUAGE: "",
    TITLE: titleTemplates[randomInt(0, titleTemplates.length - 1)],
    CONTENT: contentTemplates[randomInt(0, contentTemplates.length - 1)],
    PIC_URL_LIST: selectedImages.join(','),
    UPLOAD_TIME: createTime,
    REVIEWER: "",
    REVIEW_TEXT: "",
    REVIEW_TIME: null,
    LIKE_COUNT: String(likeCount),
    STATE: "1",
    CREATE_TIME: createTime,
    UPDATE_TIME: "2025-10-11 11:20:52",
    IS_LIKE: isLike
  };
}

/**
 * 生成指定数量的 Mock 数据
 */
function generateMockData(total = 1000) {
  const data = [];
  for (let i = 1; i <= total; i++) {
    data.push(generateUgcItem(i));
  }
  return data;
}

// 生成300条数据（用于测试）
const MOCK_DATA = generateMockData(300);

/**
 * 模拟 API 请求
 * @param {Object} params - 请求参数
 * @returns {Promise} - 返回模拟的 API 响应
 */
export function getMockUgcData(params) {
  return new Promise((resolve) => {
    // 模拟网络延迟
    setTimeout(() => {
      const { ugcType, orderBy, publishTime, keyword, page = 1, pageSize = 12 } = JSON.parse(params.params);
      
      // 过滤数据
      let filteredData = [...MOCK_DATA];
      
      // 按 UGC 类型过滤
      if (ugcType) {
        filteredData = filteredData.filter(item => item.UGC_TYPE === String(ugcType));
      }
      
      // 按关键词过滤
      if (keyword) {
        const lowerKeyword = keyword.toLowerCase();
        filteredData = filteredData.filter(item => 
          item.TITLE.toLowerCase().includes(lowerKeyword) ||
          item.CONTENT.toLowerCase().includes(lowerKeyword)
        );
      }
      
      // 按发布时间过滤
      if (publishTime) {
        const now = new Date();
        const filterDate = new Date(now.getTime() - parseInt(publishTime) * 24 * 60 * 60 * 1000);
        filteredData = filteredData.filter(item => {
          const createTime = new Date(item.CREATE_TIME);
          return createTime >= filterDate;
        });
      }
      
      // 排序
      if (orderBy === 'hot') {
        // 按点赞数排序
        filteredData.sort((a, b) => parseInt(b.LIKE_COUNT) - parseInt(a.LIKE_COUNT));
      } else {
        // 按时间排序（默认）
        filteredData.sort((a, b) => new Date(b.CREATE_TIME) - new Date(a.CREATE_TIME));
      }
      
      // 分页
      const start = (page - 1) * pageSize;
      const end = start + pageSize;
      const pageData = filteredData.slice(start, end);
      
      // 返回数据
      resolve({
        code: 1,
        result: 1,
        msg: "success",
        data: {
          ugcContentList: pageData,
          isNotice: 0,
          pageTotal: Math.ceil(filteredData.length / pageSize)
        }
      });
    }, 300); // 300ms 延迟模拟网络请求
  });
}

